import * as yup from 'yup'

export const dateRule = yup
  .string()
  .nullable()
  .test('format', 'Date must be in the format DD.MM.YYYY', (value) => {
    if (!value) return true // Allow null or empty values
    return /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/.test(value)
  })
  .test('valid-date', 'Invalid date', (value) => {
    if (!value) return true
    // Split the DD.MM.YYYY string into parts
    const [day, month, year] = value.split('.')
    // Create date using YYYY-MM-DD format for proper parsing
    const date = new Date(`${year}-${month}-${day}`)

    // Check if it's a valid date and also verify the day matches
    // This handles cases like 31.04.2024 (April has 30 days)
    return (
      !isNaN(date.getTime()) &&
      date.getDate() === parseInt(day, 10) &&
      date.getMonth() + 1 === parseInt(month, 10) &&
      date.getFullYear() === parseInt(year, 10)
    )
  })
